function MissingDataTable({ compareResult }) {
  return (
    <div className="card p-3 mb-3">
      <h6>Missing Data</h6>
      <div className="table-responsive">
        <table className="table table-bordered table-striped">
          <thead className="table-dark">
            <tr>
              <th>#</th>
              <th>ENT_NUM</th>
              <th>SDN_NAME</th>
              <th>SDN_TYPE</th>
              <th>Program</th>
              <th>Title</th>
              <th>Call_Sign</th>
              <th>Vessel_Type</th>
              <th>Tonnage</th>
              <th>GRT</th>
              <th>Vessel_Flag</th>
              <th>Vessel_Owner</th>
              <th>Remarks</th>
            </tr>
          </thead>
          <tbody>
            {compareResult.map((row, idx) => (
              <tr key={row.id}>
                <td>{idx + 1}</td>
                <td>{row.ENT_NUM}</td>
                <td>{row.SDN_NAME}</td>
                <td>{row.SDN_TYPE}</td>
                <td>{row.Program}</td>
                <td>{row.Title}</td>
                <td>{row.Call_Sign}</td>
                <td>{row.Vessel_Type}</td>
                <td>{row.Tonnage}</td>
                <td>{row.GRT}</td>
                <td>{row.Vessel_Flag}</td>
                <td>{row.Vessel_Owner}</td>
                <td>{row.Remarks}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default MissingDataTable;
